<template>
  <div class="mainbody">
    <div class="content-box side" style="width: 100%">
      <el-card shadow="hover">
        <el-form label-width="100px">
          <el-form-item label="设备编号">
            <b>{{ cabinetCode }}</b>
          </el-form-item>

          <el-form-item label="设备状态" v-if="flagWorkStateControl">
            <div style="display: flex; justify-content: space-between">
              <el-select
                placeholder="请选择..."
                v-model="workStateControl.state"
                style="width: 120px"
              >
                <el-option
                  v-for="item in stateList"
                  :key="item.id"
                  :label="item.Name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-button
                type="primary"
                icon="el-icon-edit"
                @click="setWorkState"
                >下发</el-button
              >
            </div>
          </el-form-item>

          <el-form-item label="设备密码" v-if="flagSetPasswd || flagViewPasswd">
            <div style="display: flex; justify-content: space-between">
              <div>
                <el-select
                  placeholder="请选择..."
                  v-model="cabinetPasswd.userType"
                  style="width: 120px"
                >
                  <el-option
                    v-for="item in userTypeList"
                    :key="item.userType"
                    :label="item.Name"
                    :value="item.userType"
                  >
                  </el-option>
                </el-select>
                <el-button
                  plain
                  icon="el-icon-view"
                  @click="showPasswd"
                  v-if="flagViewPasswd"
                  >指令查询</el-button
                >

                <span class="interval-box">
                  {{ cabinetPasswd.oldPasswd }}
                </span>
                <el-input
                  v-model="cabinetPasswd.newPasswd"
                  style="width: 150px"
                  placeholder="8位数字密码"
                  v-if="flagSetPasswd"
                >
                </el-input>
              </div>
              <el-button
                type="primary"
                icon="el-icon-edit"
                @click="setPasswd"
                v-if="flagSetPasswd"
                >下发</el-button
              >
            </div>
          </el-form-item>

          <el-form-item
            label="设备费率"
            v-if="flagViewFeeConfig || flagSetFeeConfig"
          >
            <div style="display: flex; justify-content: space-between">
              <div>
                <el-button
                  plain
                  icon="el-icon-view"
                  @click="showFeeConfig"
                  v-if="flagViewFeeConfig"
                  >指令查询</el-button
                >

                <span class="interval-box"></span>
                <el-select
                  placeholder="请选择..."
                  v-model="delivery.feeConfigId"
                  style="width: 150px; margin-right: 35px"
                  v-if="flagSetFeeConfig"
                >
                  <el-option
                    v-for="item in FeeConfigList"
                    :key="item.id"
                    :label="item.feeName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>

                <div v-if="false">
                  生效时间：
                  <el-date-picker
                    style="width: 180px"
                    v-model="delivery.effectiveTime"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    placeholder="生效时间"
                  >
                  </el-date-picker>
                </div>

                <div v-if="false">
                  尖峰月：
                  <el-input
                    style="width: 100px"
                    v-model="delivery.topPeakMonths"
                    placeholder="6,7,8"
                  ></el-input>
                </div>
              </div>

              <el-button
                type="primary"
                icon="el-icon-edit"
                @click="setFeeConfig"
                v-if="flagSetFeeConfig"
                >下发</el-button
              >
            </div>
          </el-form-item>

          <!-- <el-form-item label="软件升级">
                <el-input
                  v-model="cabinetUpdate.softVer"
                  style="width: 150px; margin-right: 38px"
                  placeholder="版本号,如：1.002"
                >
                </el-input>

                <div v-if="false">
                  下载地址：
                  <el-input
                    v-model="cabinetUpdate.downUrl"
                    style="width: 442px"
                    placeholder="完整URL http://..."
                  />
                </div>
                <el-button type="primary" icon="el-icon-edit" @click="setUpdate"
                  >下发</el-button
                >
              </el-form-item> -->
        </el-form>

        <el-row class="card-form" v-show="showFee">
          <el-col :xs="24" :sm="12">
            <el-card shadow="hover">
              <div slot="header" class="clearfix">
                <span>时段/充电最大功率</span>
              </div>

              <div class="dl-box">
                <ul>
                  <li
                    style="margin-bottom: 12px"
                    v-for="(fee, index) in feeModel.periodFeeConfigs"
                    :key="index"
                  >
                    {{ fee.startTime }}
                    <span style="margin: 0 10px 22px">至</span>
                    {{ fee.endTime }}
                    <span style="margin: 0 10px 22px"></span>

                    <span v-if="fee.controlMode == 1">充电</span>
                    <span v-else-if="fee.controlMode == 2">放电</span>
                    <span v-else="fee.controlMode == 3">空闲</span>

                    <span v-if="fee.periodType == 1">尖</span>
                    <span v-else-if="fee.periodType == 2">峰</span>
                    <span v-else-if="fee.periodType == 3">平</span>
                    <span v-else-if="fee.periodType == 4">谷</span>
                    <span v-else="fee.periodType == 5">高尖</span>

                    <span style="margin-left: 10px">{{ fee.maxPower }}</span>
                    <span>kW</span>
                  </li>
                </ul>
              </div>
            </el-card>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-card shadow="hover">
              <div slot="header" class="clearfix">
                <span>费用</span>
              </div>
              <div class="dl-box-fee">
                <div>尖时:{{ feeModel.fee1 }} 元</div>

                <div>峰时:{{ feeModel.fee2 }} 元</div>

                <div>平时:{{ feeModel.fee3 }} 元</div>

                <div>谷时:{{ feeModel.fee4 }} 元</div>

                <div>高尖时:{{ feeModel.fee5 }} 元</div>
              </div>
            </el-card>
            <el-card shadow="hover" style="margin: 20px 0px 0px 0px">
              <div slot="header" class="clearfix">
                <span>其他</span>
              </div>

              <div class="dl-box">
                <ul>
                  <li style="margin-bottom: 12px">
                    生效时间： <span style="margin: 0 10px 22px"></span>
                    {{ feeModel.effectiveTime }}
                  </li>

                  <li style="margin-bottom: 12px; display: none">
                    尖峰月： <span style="margin: 0 10px 22px"></span>
                    <span
                      v-for="(mon, index) in feeModel.topPeakMonths"
                      style="margin: 0 10px 0px 0px"
                      :key="index"
                      >{{ mon }}</span
                    >
                  </li>
                </ul>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import {
  AxiosAjax,
  getModelData,
  getCompanyData,
  GetQueryValue,
} from "../../js/axios.config";
export default {
  data() {
    return {
      cabinetCode: "", //当前选的设备
      disabled: false,
      companyId: "",
      status: "",
      dateRange: [],
      showDeliveryDialog: false, //发指令窗口
      loading: false,
      showFee: false, //显示查询结果
      companyList: [],
      companySouList: [],
      cabinetModelList: [],
      FeeConfigList: [],
      stateList: [
        {
          Name: "停机",
          id: 2,
        },
        {
          Name: "运行",
          id: 6,
        },
      ],
      userTypeList: [
        {
          Name: "技术员",
          userType: "admin",
        },
        {
          Name: "运营商",
          userType: "customer",
        },
      ],
      delivery: {
        effectiveTime: "",
        topPeakMonths: "",
        feeConfigId: "",
      },
      cabinetPasswd: {
        userType: "customer",
        cabinetCode: "",
        newPasswd: "",
        oldPasswd: "******",
      },
      cabinetUpdate: {
        cabinetCode: "",
        softVer: "",
        downUrl: "",
        force: "",
        md5: "",
      },
      workStateControl: {
        cabinetCode: "",
        state: "",
      },
      feeModel: {
        effectiveTime: "",
        fee1: 0,
        fee2: 0,
        fee3: 0,
        fee4: 0,
        fee5: 0,
        periodFeeConfigs: [
          {
            controlMode: 0,
            endTime: "",
            periodType: 0,
            startTime: "",
          },
        ],
        topPeakMonths: [],
      },

      flagInstruct: true,
      flagSetFeeConfig: true,
      flagViewFeeConfig: true,
      flagViewPasswd: true,
      flagSetPasswd: true,
      flagWorkStateControl: true,
    };
  },
  mounted() {
    this.buttonShow();
    this.cabinetCode = this.$route.query.cabinetCodes || "";
  },
  methods: {
    buttonShow() {
      if (localStorage.getItem("fx_menu_selected_jurisdiction")) {
        let jurisdiction = JSON.parse(
          localStorage.getItem("fx_menu_selected_jurisdiction")
        );
        let obj = jurisdiction[0].children.find(
          (obj) => obj.title === "监控中心"
        );
        let obj1 = obj.children.find((obj) => obj.title === "设备管理");
        obj1.resources.forEach((element) => {
          if (element.name == "ViewFeeConfig") {
            this.flagViewFeeConfig = element.selected;
          }
          if (element.name == "SetFeeConfig") {
            this.flagSetFeeConfig = element.selected;
          }
          if (element.name == "WorkStateControl") {
            this.flagWorkStateControl = element.selected;
          }
          if (element.name == "ViewPasswd") {
            this.flagViewPasswd = element.selected;
          }
          if (element.name == "SetPasswd") {
            this.flagSetPasswd = element.selected;
          }
        });
        let arr = [
          "ViewFeeConfig",
          "WorkStateControl",
          "SetFeeConfig",
          "SetPasswd",
          "ViewPasswd",
        ];
        this.flagInstruct = arr.some((name) => {
          return obj1.resources.some(
            (item) => item.name === name && item.selected
          );
        });
      }
    },
    toggleChage() {
      this.$router.push({ name: "CabinetList" });
    },

    //初始化工具栏
    initLoad: function () {
      let _this = this;

      _this.cabinetModelList = getModelData();
      _this.companyList = getCompanyData();
      if (window.localStorage.getItem("fx_login_companyType") == "1") {
        _this.disabled = true;
      }

      let companyId = _this.$route.query.companyId || ""; //获取ID

      if (companyId) {
        _this.companyId = companyId;
      }
    },

    //显示发指令窗口
    deliveryDialogOpen: function () {
      let _this = this;
      //加载费率列表
      AxiosAjax({
        url:
          "/cabinet/feeConfig/page?index=1&size=100&companyId=" +
          _this.companyId,
        success: function (res) {
          _this.FeeConfigList = res.data.data.content;
        },
      });

      _this.showDeliveryDialog = true;
    },

    showPasswd: function () {
      let _parent = this; //父页面
      let _this = this; //当前页面
      //判断是否有父窗体
      if (typeof parent.vm != "undefined") {
        _parent = parent.vm;
      }

      //查询密码
      AxiosAjax({
        url:
          "/cabinet/cabinet/passwd/" +
          _this.cabinetCode +
          "?userType=" +
          _this.cabinetPasswd.userType,
        loading: true,
        success: function (res) {
          if (res.data.code == "000000") {
            _this.cabinetPasswd.oldPasswd = res.data.data.data;
          } else {
            _this.$message({
              type: "warning",
              message: res.data.msg,
            });
          }
        },
      });
    },
    setPasswd: function () {
      let _this = this;

      var _model = {
        cabinetCode: _this.cabinetCode,
        userType: _this.cabinetPasswd.userType,
        newPasswd: _this.cabinetPasswd.newPasswd,
        oldPasswd: "",
      };

      if (
        _this.cabinetPasswd.newPasswd.length > 8 ||
        _this.cabinetPasswd.newPasswd.length < 6
      ) {
        _this.$message({
          type: "warning",
          message: "6-8位数字密码",
        });

        return;
      }

      //设置密码
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinet/setPasswd",
        data: _model,
        loading: true,
        successMsg: "指令已发送",
        success: function (res) {
          console.log(res.data.msg);

          _this.$message({
            type: "warning",
            message: res.data.msg,
          });
        },
      });
    },
    setUpdate: function () {
      let _this = this;

      _this.cabinetUpdate.downUrl =
        "http://ms.fuxinsz.com/Package/FuXinEnergy_" +
        _this.cabinetUpdate.softVer +
        ".zip";

      var _model = {
        cabinetCode: _this.cabinetCode,
        force: 0,
        downUrl: _this.cabinetUpdate.downUrl,
        softVer: _this.cabinetUpdate.softVer,
        md5: "",
      };

      if (_this.cabinetUpdate.softVer.length < 3) {
        _this.$message({
          type: "warning",
          message: "请输入版本号",
        });
        return;
      }

      if (_this.cabinetUpdate.downUrl.length < 10) {
        _this.$message({
          type: "warning",
          message: "下载地址不能为空",
        });

        return;
      }

      if (_this.cabinetUpdate.downUrl.indexOf("http") == -1) {
        _this.$message({
          type: "warning",
          message: "请输入正确的下载地址",
        });

        return;
      }

      //设置密码
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinet/updateSoft",
        data: _model,
        loading: true,
        successMsg: "指令已发送",
        success: function (res) {
          console.log(res.data.msg);

          _this.$message({
            type: "warning",
            message: res.data.msg,
          });
        },
      });
    },
    showFeeConfig: function () {
      //查询费率
      let _this = this;

      _this.showFee = false;

      AxiosAjax({
        method: "get",
        url: "/cabinet/cabinet/feeConfig/" + _this.cabinetCode,
        loading: true,
        success: function (res) {
          if (res.data.data.code == "000000") {
            _this.showFee = true;
            _this.feeModel = res.data.data.data;
          } else {
            _this.$message({
              type: "warning",
              message: res.data.data.msg,
            });
          }
        },
      });
    },
    setFeeConfig: function () {
      //设置费率

      let _this = this;
      _this.showFee = false;

      var dataMode = {
        cabinetCodes: [_this.cabinetCode],
        effectiveTime: _this.delivery.effectiveTime,
        feeConfigId: _this.delivery.feeConfigId,
        topPeakMonths: [],
      };

      if (_this.delivery.topPeakMonths.length > 0) {
        dataMode.topPeakMonths = _this.delivery.topPeakMonths.split(",");
      }

      //下发费率
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinet/feeConfigIssue",
        data: dataMode,
        loading: true,
        success: function (res) {
          console.log(res.data.msg);

          if (res.data.code == "000000") {
            console.log(res.data.msg);
            _this.$message({
              type: "warning",
              message: res.data.msg,
            });
          }
        },
      });
    },
    setWorkState: function () {
      //设置费率
      let _this = this;

      var dataMode = {
        cabinetCode: _this.cabinetCode,
        state: _this.workStateControl.state,
      };

      //下发费率
      AxiosAjax({
        method: "post",
        url: "/cabinet/cabinet/workStateControl",
        data: dataMode,
        loading: true,
        success: function (res) {
          console.log(res.data.msg);
          if (res.data.code == "000000") {
            console.log(res.data.msg);
            _this.$message({
              type: "success",
              message: res.data.msg,
            });
          }
        },
      });
    },
  },
  created: function () {
    //加载数据
    this.initLoad();
    this.deliveryDialogOpen();
  },
};
</script>
<style scoped>
.toolbar-box .more-box {
  justify-content: flex-start;
}

.toolbar-box .more-box dl {
  margin-right: 10px;
}

.interval-box {
  width: 120px;
  display: inline-block;
  margin: 0px 10px;
}
.dl-box-fee div {
  height: 35px;
  line-height: 35px;
}
.mainbody {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Monitor/OperateDevice.vue